<template>
  <e-view :title="'APP.LEFTCONTAINERTITLE' | eLocales"
          :subtitle="'APP.LEFTCONTAINERSUBTITLE' | eLocales"
          :hasPadding="false"
          :hasToolbar="true"
          :closeable="false"
          :collapsible="false"
          size="is-fixed"
          :basisWidth="400">
    <template v-if="appData.selectedItem && activeSearch" slot="header-right">
      <b-button @click="gotoSelectedSearchItem">{{'APP.GOTO' | eLocales}}</b-button>
    </template>
    <template #toolbar-right>
      <e-search type="basic" :placeholder="'APP.SEARCHFORENTRY' | eLocales" @search="search"></e-search>
    </template>
    <e-v-navigation ref="navigation" :activeSearch="activeSearch">
    </e-v-navigation>
  </e-view>
</template>

<script>
import {Text} from '@elo/core';
import {EViewMixin} from '@elo/ui';

import ContentViewer from './components/ContentViewer';
import EVNavigation from './components/EVNavigation';

export default {
  name: 'ExportViewer',
  components: {EVNavigation},
  mixins: [EViewMixin],
  inject: ['appData'],
  data() {
    return {
      activeSearch: false
    };
  },
  mounted() {
    this.$openView({
      key: 'Content',
      type: ContentViewer,
      events: {}
    });
  },
  methods: {
    search(query) {
      const searchableProps = [
        'name', 'xDate', 'iDate', 'desc'
      ];
      const searchResult = [];

      this.activeSearch = !!query;

      if (query) {
        // Laufe über alle Einträge und suche in den props nach dem Begriff. Bei einem Treffer wird
        // sich der Fundort gemerkt (kommt aus Sprachdatei oder bei den objKeys der Indexfeldname)
        window.json.items.forEach((item) => {
          item.match = {};

          searchableProps.forEach((prop) => {
            if (!item.match.hit && item[prop]) {
              if (item[prop].toLowerCase().indexOf(query.toLowerCase()) > -1) {
                if (prop === 'name') {
                  item.match.hit = Text.getText('APP.COLUMNLABELNAME');
                } else {
                  item.match.hit = Text.getText(`APP.${prop.toUpperCase()}`) || '';
                }
                searchResult.push(item);
              } else if (item.keys) {
                item.keys.forEach((key) => {
                  if (!item.match.hit && key.text.toLowerCase().indexOf(query.toLowerCase()) > -1) {
                    const mask = window.json.masks[item.mask];

                    const maskLine = mask.lines[key.key];

                    if (maskLine) {
                      item.match.hit = maskLine.name;
                    }
                    searchResult.push(item);
                  }
                });
              }
            }
          });
        });
      }
      if (!this.activeSearch) {
        this.appData.selectedItem = null;
      }
      this.appData.searchListConfig.items = searchResult;
    },
    gotoSelectedSearchItem() {
      const path = {path: [{property: 'id', value: 0}]};

      this.appData.selectedItem.path.forEach((p) => {
        if (p && isFinite(parseInt(p, 10))) {
          path.path.push({property: 'id', value: Number(p)});
        }
      });
      path.path.push({
        property: 'id',
        value: Number(this.appData.selectedItem.id)
      });

      this.search(null);
      this.$refs.navigation.$refs.tree.goto(path, 0);
    }
  }
};
</script>

<style>

</style>
